/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { Button } from 'reactstrap';
import { IEveFormViewProps } from './eve-form';
import { RichTextComponent } from '@msdyn365-commerce/core-internal';

export default (props: IEveFormViewProps) => {
    const {
        handleSubmit,
        resetForm,
        statusMessage,
        config: { formTitle, formInstructions, resetButtonText, showResetButton, submitButtonText }
    } = props;

    const items = props.slots && props.slots.content && props.slots.content.length > 0 ? props.slots.content : [];

    return (
        <div className='eve-form'>
            <h2 className='eve-form__heading'>{formTitle}</h2>
            <RichTextComponent className='eve-form__instructions' text={formInstructions} />
            {items}
            <h2 className='eve-form__heading'>{statusMessage}</h2>
            <div className='eve-form__button-container'>
                <Button className={'eve-form__submit-button msc-button'} onClick={handleSubmit}>
                    {submitButtonText}
                </Button>
                {showResetButton ? (
                    <Button className={'eve-form__reset-button msc-button'} onClick={resetForm}>
                        {resetButtonText}
                    </Button>
                ) : (
                    <></>
                )}
            </div>
        </div>
    );
};
